import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axiosInstance from "../../utilities/Axios";
import { useState } from "react";
import { useSnackbar } from "notistack";

export default function AlertDialog(props: {
  openAlert: boolean;
  onCloseAlert: any;
  data: any;
  action: string;
}) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const deleteTicket = async (id: number) => {
    if (props.action == "ticket") {
      try {
        const url = `${process.env.REACT_APP_API_ORIGIN}/v1/ticket/${id}`;

        const response = await axiosInstance.delete(url);
        enqueueSnackbar("Ticket Deleted Successfully!!!", {
          variant: "success",
        });
        handleClose();
      } catch (err: any) {
        enqueueSnackbar(
          `Ticket Deletion Unsuccessful!!! ${err.response.data.error}`,
          { variant: "error" }
        );
        console.error(err);
      }
    } else if (props.action == "countryProcess") {
      try {
        const url = `${process.env.REACT_APP_API_ORIGIN}/v1/country-process/${id}`;

        const response = await axiosInstance.delete(url);
        enqueueSnackbar("Country Process Deleted Successfully!!!", {
          variant: "success",
        });
        handleClose();
      } catch (err: any) {
        enqueueSnackbar(
          `Country Process Deletion Unsuccessful!!! ${err.response.data.error}`,
          { variant: "error" }
        );
        console.error(err);
      }
    } else if (props.action == "jobTitle") {
      try {
        const url = `${process.env.REACT_APP_API_ORIGIN}/v1/job-titles/${id}`;

        const response = await axiosInstance.delete(url);

        enqueueSnackbar("Job Title Deleted Successfully!!!", {
          variant: "success",
        });
        handleClose();
      } catch (err: any) {
        enqueueSnackbar(
          `Job Title Deletion Unsuccessful!!! ${err.response.data.error}`,
          { variant: "error" }
        );
        console.error(err);
      }
    } else if (props.action == "resume") {
      try {
        const url = `${process.env.REACT_APP_API_ORIGIN}/v1/resume/${id}`;

        const response = await axiosInstance.delete(url);

        enqueueSnackbar("Resume Deleted Successfully!!!", {
          variant: "success",
        });
        handleClose();
      } catch (err: any) {
        enqueueSnackbar(
          `Resume Deletion Unsuccessful!!! ${err.response.data.error}`,
          { variant: "error" }
        );
        console.error(err);
      }
    } else if (props.action == "subAgent") {
      try {
        const url = `${process.env.REACT_APP_API_ORIGIN}/v1/sub-agents/${id}`;

        const response = await axiosInstance.delete(url);
        enqueueSnackbar("Sub Agent Deleted Successfully!!!", {
          variant: "success",
        });
        handleClose();
      } catch (err: any) {
        enqueueSnackbar(
          `Sub Agent Deletion Unsuccessful!!! ${err.response.data.error}`,
          { variant: "error" }
        );
        console.error(err);
      }
    } else if (props.action == "staff") {
      try {
        const url = `${process.env.REACT_APP_API_ORIGIN}/v1/staffs/${id}`;

        const response = await axiosInstance.delete(url);
        enqueueSnackbar("Staff Deleted Successfully!!!", {
          variant: "success",
        });
        handleClose();
      } catch (err: any) {
        enqueueSnackbar(
          `Staff Deletion Unsuccessful!!! ${err.response.data.error}`,
          { variant: "error" }
        );
        console.error(err);
      }
    } else if (props.action == "template") {
      try {
        const url = `${process.env.REACT_APP_API_ORIGIN}/v1/country-process-tpl/${id}`;

        const response = await axiosInstance.delete(url);
        enqueueSnackbar("Country Template Deleted Successfully!!!", {
          variant: "success",
        });
        handleClose();
      } catch (err: any) {
        enqueueSnackbar(
          `Country Template Deletion Unsuccessful!!! ${err.response.data.error}`,
          { variant: "error" }
        );
        console.error(err);
      }
    } else if (props.action == "process") {
      try {
        const url = `${process.env.REACT_APP_API_ORIGIN}/v1/process/${id}`;

        const response = await axiosInstance.delete(url);
        enqueueSnackbar("Process Deleted Successfully!!!", {
          variant: "success",
        });
        handleClose();
      } catch (err: any) {
        enqueueSnackbar(
          `Process Deletion Unsuccessful!!! ${err.response.data.error}`,
          { variant: "error" }
        );
        console.error(err);
      }
    } else if (props.action == "skill") {
      try {
        const url = `${process.env.REACT_APP_API_ORIGIN}/v1/skills/${id}`;

        const response = await axiosInstance.delete(url);
        enqueueSnackbar("Skill Deleted Successfully!!!", {
          variant: "success",
        });
        handleClose();
      } catch (err: any) {
        enqueueSnackbar(
          `Skill Deletion Unsuccessful!!! ${err.response.data.error}`,
          { variant: "error" }
        );
        console.error(err);
      }
    }
  };

  const handleClose = () => {
    props.onCloseAlert();
  };

  return (
    <div>
      <Dialog
        open={props.openAlert}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Delete Confirmation"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are You Sure Want to Delete?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              deleteTicket(props.data.id);
            }}
            autoFocus
            style={{
              color: "red",
              fontWeight: "bold",
              textTransform: "none",
              fontSize: 16,
            }}
          >
            Delete
          </Button>
          <Button
            onClick={handleClose}
            style={{ textTransform: "none", fontSize: 16 }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
